import { IBridgeOptions } from './interface'

/**
 * 容器事件，仅在原生运行下有效
 * 当app应用从前台回到后台时会触发 appDisappear 事件 <br>
 * 参考 http://document.lightyy.com/zh-cn/api/olight-event.html#appdisappear
 *
 * @param {IBridgeOptions} { success, fail, complete }
 */
function appDisappearSync({ success, fail, complete }: IBridgeOptions) {
  if (window.LightJSBridge) {
    window.LightJSBridge.AppDidEnterBackground = () => {
      success && success()
      complete && complete()
    }
  } else {
    fail && fail()
    complete && complete()
  }
}

/**
 * 当app应用从前台回到后台时会触发<br>
 * 一个异步接口，支持 Promise 化使用
 */
function appDisappear() {
  return new Promise((resolve, reject) => {
    if (window.LightJSBridge) {
      window.LightJSBridge.AppDidEnterBackground = () => {
        resolve()
      }
    } else {
      reject('window.LightJSBridge 对象不存在')
    }
  })
}

export { appDisappearSync }
